<template>

  <div class="py-4 container-fluid">
    <div class="row">


      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Producto</p>
              <argon-button v-if="(user.role !== '1' && form.status === 0) || user.role === '1'" color="success"
                size="sm" class="ms-auto" @click="save">Guardar</argon-button>
              <argon-button v-if="(user.role !== '1' && form.status === 0) || (user.role === '1' && form.status === 0)"
                color="success" size="sm" class="" style="margin-left: 5px;" @click="confirm">Formalizar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-12" style="position: relative;">
                <label for="example-text-input" class="form-control-label">Proveedor</label>
                <argon-input type="text" v-model="form.supplier" @input="filterSuppliers" />

                <!-- Lista de sugerencias -->
                <ul v-if="filteredSuppliers.length > 0" class="suggestions"
                  style="position: absolute; background: #ccc; top: 75px; border-radius: 5px; width: 80%;">
                  <li v-for="supplier in filteredSuppliers.slice(0, 5)" :key="supplier.id"
                    @click="selectSupplier(supplier)">
                    {{ supplier.supplier }}
                  </li>
                </ul>


              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Telefono</label>
                <argon-input type="text" v-model="form.phone" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Email</label>
                <argon-input type="text" v-model="form.email" />
              </div>

            </div>
          </div>
        </div>

        <div class="card" v-if="form.id != 0">

          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Lista de compras</p>
              <argon-button v-if="user.role === '1'" color="success" size="sm" class="ms-auto"
                @click="openModal">Agregar
                compra</argon-button>
              <argon-button v-if="user.role !== '1' && form.status === 0" color="success" size="sm" class="ms-auto"
                @click="openModal">Agregar compra</argon-button>
            </div>
          </div>

          <div class="card-body">
            <div class="row">

              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Cantidad (Und - Mts)</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio
                        Unidad</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                      </th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                        v-if="(user.role !== '1' && form.status === 0) || user.role === '1'">
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="value in data.data" :key="value.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ value.inventory.name }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ value.quantity }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat(value.price).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat(value.total_price).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ new Date(value.updated_at).toLocaleDateString('es-ES') }}
                        </span>
                      </td>

                      <td class="align-middle text-center"
                        v-if="(user.role !== '1' && form.status === 0) || user.role === '1'">

                        <!-- Editar -->
                        <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip" data-original-title="Editar registro">
                          <i class="fa fa-pencil-alt"></i>
                        </a>

                        <a @click="deleteRegister(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          style="margin-left: 15px;" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>

                      </td>
                    </tr>

                    <!-- No hay registros -->
                    <tr v-if="!data?.data || data.data.length==0" >
                      <td colspan="6" class="text-center text-secondary text-sm">
                        No hay registros
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal Asignar tecnico -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar compra</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Insumo</label>
                <select v-model="purchase.inventory_id" ref="processesSelect" id="processes" class="form-select select2"
                  style="width:100%;">
                  <option v-for="process in insumos" :key="process.id" :value="process.id">
                    {{ process.name }} ({{ process.ref }})
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad (Und - Mts)</label>
                <input type="text" v-model="purchase.quantity" id="amount" class="form-control"
                  placeholder="Ingrese el valor">
              </div>
              <div class="mb-3">
                <label for="amount" class="form-label">Precio Unidad</label>
                <input type="text" v-model="formattedPrice" id="amount" class="form-control"
                  placeholder="Ingrese el valor">
              </div>
              <div class="mb-3">
                <label for="amount" class="form-label">Total</label>
                <input type="text" v-model="totalPrice" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
//import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      showMenu: false,
      modalBudget: null,
      isFinish: false,
      user: {},
      form: {
        id: 0,
        supplier: '',
        phone: '',
        email: '',
        status: 0,
      },
      size: {
        size: '',
        color_id: '',
        model_id: '',
        quantity: 0,
        status: 1
      },
      insumos: [],
      colors: [],
      sizes: [],
      purchases: [],
      purchase: {
        id: 0,
        purchase_id: 0,
        inventory_id: 0,
        quantity: 0,
        price: 0,
        total_price: 0,
      },
      data: {},
      modal: {
        id: 0,
        user_id: null,
        project_id: null,
        amount: "",
        status: "active"
      },
      modalEvidencia: [],
      suppliers: [],
      filteredSuppliers: [],
    };
  },
  components: { ArgonInput, ArgonButton },
  computed: {
    formattedPrice: {
      get() {
        return this.purchase.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.purchase.price = Math.floor(value.replace(/\./g, "") || 0);
        this.purchase.total_price = Math.floor(this.purchase.price * this.purchase.quantity);
      },
    },
    totalPrice: {
      get() {
        return this.purchase.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.purchase.total_price = Math.floor(value.replace(/\./g, "") || 0);
        this.purchase.price = this.purchase.quantity > 0 ? Math.floor((this.purchase.total_price / this.purchase.quantity)) : 0;
      },
    },
  },
  methods: {
    async getSuppluers() {
      this.suppliers = await this.$store.dispatch('purchases/getAll');
    },
    filterSuppliers() {
      const query = this.form.supplier.toLowerCase();
      this.filteredSuppliers = this.suppliers.filter((supplier) =>
        supplier.supplier.toLowerCase().includes(query)
      );
    },
    selectSupplier(supplier) {
      this.form.supplier = supplier.supplier;
      this.form.email = supplier.email;
      this.form.phone = supplier.phone;
      this.filteredSuppliers = []; // Oculta las sugerencias
    },
    getIconClass(status) {
      if (status === 0) {
        return 'fa fa-circle'; // Ícono de clic
      } else if (status === 1) {
        return 'fa fa-check-circle text-success'; // Ícono de check verde
      } else if (status === 2) {
        return 'fa fa-times-circle text-danger'; // Ícono de X roja
      }
      return ''; // Devuelve una cadena vacía si no coincide con ningún estado
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    async getData() {
      await this.$store.dispatch('purchasesDetails/getData', this.form.id);
      this.data = this.$store.state.purchasesDetails.getData;

      console.log(this.data);
    },
    async getInsumos() {
      this.insumos = await this.$store.dispatch('inventory/getAll');
    },
    async confirm() {

      await Swal.fire({
        icon: 'info',
        title: 'Formalizar compra',
        text: 'Al formalizar la compra ya no se podra editar los registros ni los detalles de la compra',
        confirmButtonText: 'Aceptar',
        backdrop: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.status = 1;
          this.save();
        }
      });
    },
    async save() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("purchases/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.form = response.data;
              this.form.id = response.data.id || 0;

              this.purchase.purchase_id = response.data.id || 0;

            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitForm() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("purchasesDetails/save", this.purchase);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.purchase.inventory_id = 0;
              this.purchase.quantity = 0;
              this.purchase.price = 0;
              this.purchase.total_price = 0;

              $(this.$refs.processesSelect).val('').trigger('change');

              this.getData();
              this.closeModal();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },

    async editRegister(value) {
      this.purchase.id = value.id;
      this.purchase.inventory_id = value.inventory_id;
      this.purchase.purchase_id = value.purchase_id;
      this.purchase.quantity = value.quantity;
      this.purchase.price = value.price;
      this.purchase.total_price = value.total_price;

      $(this.$refs.processesSelect).val(value.inventory_id).trigger('change');

      this.openModal();



    },

    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("purchasesDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

  },
  mounted() {

    this.getSuppluers();

    this.user = JSON.parse(localStorage.getItem('user'));

    const route = useRoute();
    const dataEdit = route.params.data;

    this.getInsumos();

    if (dataEdit) {



      try {
        const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear

        this.data = params;
        if (params && params.id) {

          this.purchase.purchase_id = params.id || 0;

          this.form.id = params.id || 0;
          this.form.supplier = params.supplier || '';
          this.form.phone = params.phone || '';
          this.form.email = params.email || '';
          this.form.status = params.status || 0;

          this.getData();
        }
      } catch (error) {
        console.error("Error al parsear los datos del registro:", error);
      }
    }

    this.$nextTick(() => {
      $(this.$refs.processesSelect).select2({
        placeholder: 'Seleccione un insumo',
        allowClear: true,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.processesSelect).on('change', () => {
        this.purchase.inventory_id = $(this.$refs.processesSelect).val();
      });
    });


    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}
</style>
